<template>
  <div class="main-content">
    <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
    <div v-if="!loading && orders">

      <div class="card mb-3 back-white">
        <div class="card-body flex justify-content-between">
          <span>Всего заявок: <strong>{{ orders.length }}</strong> (<strong>{{ ordersSum }}</strong>)</span>
          <span v-if="dialogs && dialogs.length">Запросов: <strong>{{ dialogs.length }}</strong></span>
        </div>
      </div>

      <div class="card" v-for="order in orders">
        <div class="card-body">
          <OrderDetails
            :order="order"
            :smsPayment="smsToOrders && smsToOrders[order.id]"
            :refreshOrder="(silent) => getOrders(silent)"
          />
        </div>
        <div class="card-footer">
          <div v-if="actions[order.id].rejectOrderOpen">
            <div class="input-group mb-3">
              <input type="text" v-model="actions[order.id].rejectComment" placeholder="Причина отказа"
                     class="form-control"/>
              <LoadingButton
                title="В отказ"
                className="btn btn-outline-danger"
                :loading="actions[order.id].loading"
                :onClick="() => updateOrder(order.id, 'reject_order')"
              />
            </div>
          </div>

          <div v-if="actions[order.id].orderCorrectionOpen">
            <div class="input-group mb-3">
              <input type="text" v-model="actions[order.id].correction" placeholder="Данные для коррекции"
                     class="form-control"/>
              <LoadingButton
                title="Отправить"
                color="#5BBFDE"
                className="btn btn-outline-success"
                :loading="actions[order.id].loading"
                :onClick="() => updateOrder(order.id, 'send_correction')"
              />
            </div>
          </div>

          <div v-if="actions[order.id].orderShift">
            <div class="input-group mb-3">
              <DateSelectProps
                ref="dateSelect"
                :disabled="true"
                :useDisabledDates="actions[order.id].shiftDate"
                :customShortCutsDates="false"
                :onSelect="(date, formated) => actions[order.id].shiftDate = formated"
                :selectedDate="actions[order.id].shiftDate"
              />
              <LoadingButton
                title="Перенести"
                color="#5BBFDE"
                className="btn btn-outline-success"
                :loading="actions[order.id].loading"
                :onClick="() => updateOrder(order.id, 'shift_order')"
              />
            </div>
          </div>

          <div v-if="actions[order.id].orderQuestionOpen">
            <div class="input-group mb-3">
              <input type="text" v-model="actions[order.id].comment" placeholder="Вопрос менеджеру"
                     class="form-control"/>
              <LoadingButton
                title="Отправить"
                color="#5BBFDE"
                className="btn btn-outline-success"
                :loading="actions[order.id].loading"
                :onClick="() => updateOrder(order.id, 'send_question')"
              />
            </div>
          </div>

          <div v-if="actions[order.id].orderCommentOpen">
            <div class="input-group mb-3">
              <input type="text" v-model="actions[order.id].comment" placeholder="Ваш комментарий"
                     class="form-control"/>
              <LoadingButton
                title="Сохранить"
                color="#5BBFDE"
                className="btn btn-outline-success"
                :loading="actions[order.id].loading"
                :onClick="() => updateOrder(order.id, 'add_comment')"
              />
            </div>
          </div>

          <div v-if="actions[order.id].orderLineActionsOpen" class="mb-3 line_btns_block">
            <LoadingButton
              title='<i class="icon-fa icon-fa-backward rotate-up"></i> Первая'
              color="#5BBFDE"
              :loading="actions[order.id].loading"
              :onClick="() => updateOrder(order.id, 'change_line', 'first')"
              className="btn btn-default"
            />
            <LoadingButton
              title='<i class="icon-fa icon-fa-arrow-circle-up"></i>'
              :loading="actions[order.id].loading"
              color="#5BBFDE"
              :onClick="() => updateOrder(order.id, 'change_line','up')"
              className="btn btn-default"
            />
            <LoadingButton
              title='<i class="icon-fa icon-fa-arrow-circle-down"></i>'
              color="#5BBFDE"
              :loading="actions[order.id].loading"
              :onClick="() => updateOrder(order.id, 'change_line','down')"
              className="btn btn-default"
            />
            <LoadingButton
              title='<i class="icon-fa icon-fa-backward rotate-down"></i> Последняя'
              color="#5BBFDE"
              :loading="actions[order.id].loading"
              :onClick="() => updateOrder(order.id, 'change_line','last')"
              className="btn btn-default"
            />
          </div>

          <div class="flex justify-content-between">
            <div class="flex">
              <dropdown-menu menu-title="" dark-mode="auto" class="menu">
                <section @click="openDialog(order.id, 'orderLineActionsOpen')" class="option">
                  <button><strong>Изменить очередь</strong></button>
                  <span class="desc">меняет очередность заявок</span>
                </section>

                <section @click="openDialog(order.id, 'orderCorrectionOpen')" class="option">
                  <button><strong>Коррекция</strong></button>
                  <span class="desc">изменения кол. смена адреса и тд</span>
                </section>

                <section @click="openDialog(order.id, 'orderQuestionOpen')" class="option">
                  <button><strong>Вопрос менеджеру</strong></button>
                  <span class="desc">новая заявка, стоимость и тд</span>
                </section>

                <!--                <section @click="openDialog(order.id, 'orderCommentOpen')" class="option">-->
                <!--                  <button>Добавить комментарий</button>-->
                <!--                  <span class="desc">личный комментарий на заявку</span>-->
                <!--                </section>-->

                <section @click="openDialog(order.id, 'orderShift')" class="option">
                  <button><strong>Перенос</strong></button>
                  <span class="desc">перенос на другую дату</span>
                </section>

                <section @click="updateOrder(order.id, 'no_reply')" class="option">
                  <button><strong>Недозвон</strong></button>
                  <span class="desc">станет последней в очереди с пометкой "недозвон"</span>
                </section>

                <section @click="openDialog(order.id, 'rejectOrderOpen')" class="option">
                  <button><strong>Отказ</strong></button>
                  <span class="desc">отмена заказчиком</span>
                </section>
              </dropdown-menu>
              <button @click="openDialog(order.id, 'orderCommentOpen')" class="btn btn-outline-success ml-2">
                Комментарий
              </button>
            </div>
            <div>
              <button @click="mixinGoToRouter('TabletOrder', {orderId: order.id})" class="btn btn-outline-info">
                {{
                  +order.pay_method !== 3 && order.credit_card_id ? 'Взять наличные и отменить предоплату' : 'Доставить'
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import moment from "moment";
import OrderDetails from "@/views/tablet/orders/components/OrderDetails";
import dropdownMenu from './components/DropDown'
import DateSelectProps from '@/components/dateSelect/DateSelectProps';

export default {
  components: {
    LoadingButton,
    OrderDetails,
    dropdownMenu,
    DateSelectProps,
  },
  data() {
    return {
      smsToOrders: {},
      loading: false,
      btnLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      orders: null,
      actionBtnLoading: {},
      actions: {},
      dialogs: [],
      ordersSum: 0,
      defaultState: {
        orderLineActionsOpen: false,
        orderCorrectionOpen: false,
        orderQuestionOpen: false,
        orderCommentOpen: false,
        rejectOrderOpen: false,
        orderShift: false,
        comment: null,
        question: null,
        correction: null,
        rejectComment: null,
        loading: false,
        shiftDate: moment().add(1, 'days')
      }
    }
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    async updateOrder(orderId, type, action = null) {
      if (this.actions[orderId].loading) return;
      this.actions[orderId].loading = true;
      if (action) this.actions[orderId].action = action;

      // let response;
      // if (type === 'send_question' || type === 'send_correction') {
      //   const {data} = await api.post('orders/updateOrderByRunner', {
      //     type: type,
      //     order_id: orderId,
      //     data: this.actions[orderId]
      //   })
      //   response = data;
      // } else {

      const {data} = await api.post('orders/updateOrderByRunner', {
        type: type,
        order_id: orderId,
        data: this.actions[orderId]
      })
      // response = data;
      // }

      if (data.success) {
        const index = this.orders.findIndex((o) => o.id === orderId);
        switch (type) {
          case 'reject_order':
          case 'shift_order':
            this.orders = this.orders.filter((o) => o.id !== orderId);
            break;
          case 'send_question':
          case 'send_correction':
            break;
          case 'change_line':
          case 'no_reply':
            this.orders = data.orders;
            break;
          case 'add_comment':
            if (!this.orders[index].extra_options.runner_comments) {
              this.orders[index].extra_options.runner_comments = [];
              this.orders = [...this.orders];
              console.log('update orders');
            }
            this.orders[index].extra_options.runner_comments.push({
              user_name: this.$currentUser.name,
              message: this.actions[orderId].comment
            })
            this.orders[index] = {...this.orders[index]}
            break;
        }
        this.closeOrderDialog(orderId);
        toastr["success"]("Сохранено", "Успешно");
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }

      this.actions[orderId].loading = false;
    },
    async rejectOrder(orderId) {
      this.closeOrderDialog(orderId);
    },
    openDialog(orderId, index) {
      this.closeOrderDialog(orderId);
      this.actions[orderId][index] = true;
    },
    closeOrderDialog(orderId) {
      this.actions[orderId] = {...this.defaultState}
    },
    async getOrders(silent = false) {
      if (!silent) {
        this.loading = true;
      }
      const {data} = await api.index('orders/gerRunnerOrders');
      if (data.success) {
        const actionBtnLoading = {};
        const actions = {};
        const dialogs = [];
        let sum = 0;
        data.orders.map((o) => {
          actionBtnLoading[o.id] = false;
          actions[o.id] = {...this.defaultState}
          if (o.messages) {
            dialogs.push(...o.messages);
          }
          sum += o.price;
        })
        this.smsToOrders = data.smsToOrers;
        this.ordersSum = Math.round(sum * 100) / 100;
        this.actionBtnLoading = {...actionBtnLoading};
        this.actions = {...actions};
        this.dialogs = dialogs;
        this.orders = data.orders;
      } else {
        toastr["warning"](data.message || "нет ответа сервера", "Ошибка");
      }
      this.loading = false;
    },
    moment: function (date, format = 'DD.MM.YYYY') {
      if (!date) return;
      return moment(date).format(format);
    },
  }
}

</script>

<style scoped>
.card {
  border: 2px solid #d8d8d8;
  -webkit-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
}

.back-white {
  background-color: white;
}

p {
  margin-bottom: 3px;
}

hr {
  margin: 3px 0;
}

.line_btns_block .btn {
  margin-right: 8px;
}

.card-body {
  padding: 10px !important;
}
</style>
